import styled from '../../../theme/styled-with-theme';
import { pxToRem } from '../../../styles/utils';
import { mediaQueries } from '../../../styles/media-queries';

import { Box } from '../../Box';
import Link from '../../Link';
import { GlImage } from '../../Image';
import { PhoneNumberWrapper } from '../../CtaWidget/LegacyPhoneNumberWidget/PhoneNumberWidget.styles';

export const NoOverflowBox = styled(Box)`
  overflow: hidden;
  position: relative;
`;

export const MobileImage = styled(GlImage)`
  display: block;
  width: 100%;

  ${mediaQueries.desktop} {
    display: none;
  }
`;

export const HeroText = styled('div')`
  text-align: center;
  margin: auto;
`;

export const AffiliatePhoneNumberWrapper = styled(PhoneNumberWrapper)`
  display: flex;
  flex-grow: 1;
  max-width: ${pxToRem(272)};
  width: 90%;
  justify-content: center;
  min-width: ${pxToRem(250)};

  ${mediaQueries.tablet} {
    min-width: 16.25rem;
    max-width: 20rem;
  }

  ${mediaQueries.desktop} {
    min-width: 16.25rem;
    max-width: 26.375rem;
  }
`;

export const InlineAnchor = styled(Link, {
  shouldForwardProp: (prop) => prop !== 'useLightText'
})<{ useLightText: boolean }>`
  color: ${({ theme }) => theme.color.inlineAnchor};
  font-weight: ${({ theme }) => theme.fontWeight.inlineAnchor};
  font-style: underline;
  transition: 0.2s color ease;

  &:hover {
    color: ${({ theme }) => theme.color.inlineAnchorHover};
  }

  ${mediaQueries.tablet} {
    color: ${({ theme }) => theme.color.inlineAnchor};

    &:hover {
      color: ${({ theme, useLightText }) =>
        useLightText ? theme.color.lightButton : theme.color.inlineAnchorHover};
    }
  }

  ${mediaQueries.desktop} {
    color: ${({ theme, useLightText }) =>
      useLightText ? theme.color.white : theme.color.defaultText};

    &:hover {
      color: ${({ theme, useLightText }) =>
        useLightText ? theme.color.inlineAnchorHover : theme.color.darkButton};
    }
  }
`;
